module.exports = __webpack_public_path__ + "static/media/slide-5.3526ce5d.jpg";